import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import { AuthScreen } from '../components/ui';

/** Handles the Google OAuth redirect: exchanges ?code for tokens, then enters the app. */
export function AuthCallback() {
  const { completeGoogleSignIn } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // StrictMode double-invoke guard (code is single-use)
    ran.current = true;
    const code = params.get('code');
    const oauthError = params.get('error_description') ?? params.get('error');
    if (oauthError) {
      setError(oauthError);
      return;
    }
    if (!code) {
      setError('No authorization code returned.');
      return;
    }
    completeGoogleSignIn(code)
      .then(() => navigate('/overview', { replace: true }))
      .catch((err) => setError(err instanceof Error ? err.message : 'Google sign-in failed'));
  }, [params, completeGoogleSignIn, navigate]);

  return (
    <AuthScreen>
      <p style={{ textAlign: 'center', color: 'var(--text-dim)' }}>
        {error ? `Sign-in failed: ${error}` : 'Signing you in…'}
      </p>
    </AuthScreen>
  );
}
